module.exports = __webpack_public_path__ + "img/CK.72fb9bfa.svg";